import { Rule } from 'antd/es/form';
import { general, generalFields } from 'shared/model/schemas/rules';

export const getResetPasswordScheme = (t: any): { email: Rule[] } => ({
  email: [
    general(t)['required-field'],
    ...generalFields(t).email,
  ],
});

export const getResetPasswordConfirmScheme = (t: any): { password: Rule[]; repeatPassword: Rule[] } => ({
  password: [
    general(t)['required-field'],
    ...generalFields(t).password,
  ],
  repeatPassword: [
    general(t)['required-field'],
    ...generalFields(t).password,
    general(t)['must-match']('password', t({ id: 'inputs.password' })),
  ],
});